// Events
export const GTM_EVENT_CLICK_OTHER = '_click_other';
export const GTM_EVENT_PRODUCT_CLICK = '_product_click';
export const GTM_EVENT_PRODUCT_IMPRESSION = '_product_impression';
export const GTM_EVENT_FILTER = '_filter';

// Categories
export const GTM_CATEGORY_LIST_PAGE = 'page liste';
export const GTM_CATEGORY_LIST_PAGE_CLICK_OTHER = 'clic autre - page liste';
export const GTM_CATEGORY_SEARCH_PAGE = 'recherche';
export const GTM_CATEGORY_SEARCH_PAGE_WITHOUT_RESULT =
  'page de résultats de recherche sans résultat';

export const GTM_ATTRIBUTES_BASE_PRODUCT = [
  'r',
  'rc',
  'rct',
  'name',
  'brand',
  'category_1',
  'category_2',
  'category_3',
  'list_position',
  'price_tf_original',
  'price_ati_original',
  'price_tf_after_discount',
  'price_ati_after_discount',
  'discount_ati',
  'discount_tf',
  'coupon',
  'sticker',
];
